module.exports = __webpack_public_path__ + "images/point-middle.png";